import { Button } from '@mui/material'
import { GlobalContext } from '../../../../App'
import { useContext } from 'react'

export const ButtonSelectedAgenda = () => {
  const { agenda, dispatch } = useContext(GlobalContext)

  return (
    <div className="flex flex-col items-center justify-between bg-gray-200 p-4 gap-5 text-lg rounded-lg">
      <p
        style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.0rem' }}
      >
        Agenda
      </p>
      <Button
        style={{
          backgroundColor: 'white',
          fontSize: 12,
          width: '100%',
          minHeight: '40px',
          border: '1px solid gray',
          fontWeight: 'bold',
          whiteSpace: 'normal',
          textAlign: 'center',
          padding: '8px',
        }}
        variant="text"
        color="inherit"
        onClick={() => dispatch({ field: 'agenda', value: null })}
      >
        {agenda?.length > 0 ? agenda?.[1] : 'Selecione'}
      </Button>
    </div>
  )
}
